var $bbc0fd9fb7992940$exports = {};
$bbc0fd9fb7992940$exports = {
    "replaceMessage": `Sl\xe4pp filen f\xf6r att ers\xe4tta`
};


export {$bbc0fd9fb7992940$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
